import { render, staticRenderFns } from "./MessageComposer.vue?vue&type=template&id=60c50136&"
import script from "./MessageComposer.vue?vue&type=script&lang=js&"
export * from "./MessageComposer.vue?vue&type=script&lang=js&"
import style0 from "./MessageComposer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports